// extracted by mini-css-extract-plugin
export default {"button":"fXwNn9","orderInformation":"T8J5IK","orderNumber":"zaydhR","placedOn":"buQYF3","tickets":"HKg8pn","summaryDetails":"Wm_ORf","link":"ehcsbf"};